/*
 * Obtención de las joyas principales según la administración (11/10/2026).
 * Por ahora se consiguen en las invasiones; también hay un bajo porcentaje en cofres y un drop muy bajo.
 * En estas joyas la guía muestra solo eso: no lista spots, monstruos ni cajas concretas de los archivos.
 */
export const STAFF_JEWEL_DATE = '11/10/2026'

export const staffJewelSources: Record<string, { entryId: string; name: string }> = {
  '14,13': { entryId: 'jewel-of-bless', name: 'Jewel of Bless' },
  '14,16': { entryId: 'jewel-of-life', name: 'Jewel of Life' },
  '14,14': { entryId: 'jewel-of-soul', name: 'Jewel of Soul' },
  '12,15': { entryId: 'jewel-of-chaos', name: 'Jewel of Chaos' },
}

export const JEWEL_MAIN_SOURCE = 'Por ahora se consiguen en las invasiones.'
export const JEWEL_RARE_NOTE = 'También hay un bajo porcentaje de que salgan de cofres y un drop muy bajo.'

export const isStaffJewel = (itemId?: string) => !!itemId && itemId in staffJewelSources
export const staffJewelEntryIds = new Set(Object.values(staffJewelSources).map((j) => j.entryId))
